import React, { FC, ReactElement } from 'react';
import { cn } from '@bem-react/classname';

import { User } from 'ducks/user';

import { HeaderSettings } from './Settings/Header-Settings';

import { HeaderProps } from './Header.interface';
import { getMenuCtx } from './Header.util';
import {
    colorMenuActive,
    colorMenuActiveHover,
    serviceLogoSrc,
    serviceNameLogoSrc,
} from './Header.constants';

export const cnHeader = cn('Header');

const { scripts, suggestOptions } = require('./scripts');

const {
    notifier,
    settings,
    toolsCrossNav,
    toolsHeader,
    toolsMenu,
    toolsUserAccount,
    toolsHeaderSuggest,
} = scripts;

const getMenuHTML = () => toolsMenu.desktop({ ctx: { items: getMenuCtx() } });

const getHeaderHTML = (user: User): string => {
    return toolsHeader.desktop({
        ctx: {
            tools: true,
            colorMenuActive,
            colorMenuActiveHover,
            serviceLogoSrc,
            serviceNameLogoSrc,
            serviceLogoUrl: '/',
            serviceNameLogoUrl: '/',
            formAction: '//yandex.ru/search/',
            burgerHTML: toolsCrossNav.desktop({ ctx: { env: 'yateam' } }),
            menuHTML: getMenuHTML(),
            searchSuggestHtml: toolsHeaderSuggest.desktop({ ctx: suggestOptions }),
            settingsHTML: settings.desktop({}),
            // https://st.yandex-team.ru/VCONF-914
            // chatHTML: chat.desktop.getContent({ ctx: { isYandexTeam: true } }),
            notifierHTML: notifier.desktop({ ctx: { utmSourceService: 'internal_vconf' } }),
            userHTML: toolsUserAccount.desktop({
                ctx: {
                    login: user.id,
                },
            }),
        },
    });
};

export const HeaderDesktop: FC<HeaderProps> = (props: HeaderProps): ReactElement | null => {
    const {
        user,
        isHeaderVisible,
        isSettingsVisible,
        settingsRef,
        onSettingsClose,
        replacer,
    } = props;

    if (!isHeaderVisible) return null;

    return (
        <>
            {
                replacer || (
                    <>
                        <div
                            className={cnHeader()}
                            dangerouslySetInnerHTML={{
                                __html: getHeaderHTML(user),
                            }}
                        />
                        <HeaderSettings
                            isVisible={isSettingsVisible}
                            onClose={onSettingsClose}
                            targetRef={settingsRef}
                        />
                    </>
                )
            }
        </>
    );
};
